var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _rect2, _rect3, _rect4, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError404Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 285,
    viewBox: "0 0 256 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.388 139.494L49.388 52.6933L52.534 53.6943L11.064 104.316L9.91998 101.742L77.702 101.742L77.702 112.324L5.77298 112.324L0.481978 101.742L51.533 39.3943L60.256 39.3943L60.256 139.494L49.388 139.494Z",
    fill: "#4999CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.002 140L227.002 53.199L230.148 54.2L188.678 104.822L187.534 102.248L255.316 102.248L255.316 112.83L183.387 112.83L178.096 102.248L229.147 39.9L237.87 39.9L237.87 140L227.002 140Z",
    fill: "#00A8B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4263 37.5699C82.3041 36.1734 81.1388 34.7324 79.9303 33.247C78.7219 31.7616 77.56 30.2668 76.4446 28.7625C75.3402 27.2173 74.344 25.6792 73.4559 24.1482L71.5366 20.8395L79.8862 16.0415L81.8055 19.3501C82.6936 20.8812 83.5208 22.5165 84.287 24.2559C85.0642 25.9545 85.7969 27.696 86.4852 29.4803C87.1734 31.2647 87.8445 32.9896 88.4985 34.6552L83.4263 37.5699ZM92.2559 46.8724C91.0334 47.5749 89.8883 47.7832 88.8206 47.4971C87.753 47.211 86.8579 46.4452 86.1353 45.1995C85.473 44.0577 85.2823 42.9217 85.5631 41.7916C85.8699 40.6464 86.5956 39.745 87.7401 39.0874C88.9626 38.3849 90.1077 38.1766 91.1754 38.4627C92.243 38.7488 93.1381 39.5146 93.8607 40.7602C94.523 41.902 94.7007 43.0455 94.3939 44.1906C94.1131 45.3208 93.4004 46.2147 92.2559 46.8724Z",
    fill: "#FAA700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.782 38.402C178.625 36.2552 179.49 34.032 180.377 31.7322C181.264 29.4324 182.192 27.1782 183.16 24.9696C184.181 22.7469 185.264 20.6488 186.409 18.6755L188.882 14.411L199.644 20.5951L197.17 24.8596C196.026 26.833 194.725 28.8058 193.268 30.7781C191.864 32.7362 190.383 34.6725 188.826 36.587C187.268 38.5015 185.766 40.3587 184.32 42.1587L177.782 38.402ZM173.04 54.2064C171.464 53.301 170.493 52.163 170.125 50.7925C169.758 49.4219 170.04 47.934 170.972 46.3285C171.825 44.8568 172.976 43.9128 174.425 43.4965C175.907 43.0994 177.385 43.3247 178.86 44.1724C180.436 45.0778 181.407 46.2158 181.775 47.5863C182.142 48.9568 181.86 50.4448 180.929 52.0503C180.075 53.5219 178.907 54.4563 177.425 54.8534C175.977 55.2698 174.515 55.0541 173.04 54.2064Z",
    fill: "#FAA700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9877 30.4789C96.6216 29.2592 96.2389 27.9988 95.8397 26.6975C95.4405 25.3963 95.0745 24.1011 94.7417 22.8122C94.427 21.4991 94.1817 20.2194 94.0057 18.9731L93.6254 16.2798L100.407 15.3311L100.788 18.0244C100.964 19.2707 101.072 20.5696 101.112 21.9211C101.17 23.2485 101.187 24.5924 101.164 25.9528C101.141 27.3131 101.122 28.6297 101.108 29.9026L96.9877 30.4789ZM100.319 38.9633C99.3257 39.1022 98.5157 38.9355 97.8889 38.4631C97.262 37.9907 96.877 37.2475 96.7338 36.2336C96.6026 35.3041 96.7804 34.5038 97.2673 33.8325C97.7754 33.1583 98.4942 32.7562 99.4238 32.6261C100.417 32.4872 101.227 32.654 101.854 33.1264C102.481 33.5987 102.866 34.3419 103.009 35.3558C103.14 36.2853 102.952 37.0871 102.443 37.7613C101.957 38.4326 101.248 38.8333 100.319 38.9633Z",
    fill: "#FAA700"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126.4,
    y: 135.983,
    width: 7.82139,
    height: 19.4618,
    rx: 3.91069,
    fill: "#6261D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.866 189.503V187.003H40.366C28.1862 187.003 18.3125 196.877 18.3125 209.056V230.281C18.3125 242.461 28.1862 252.334 40.366 252.334H42.866V249.834V189.503Z",
    fill: "#8C8C8C",
    stroke: "#6261D6",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.279 187.003H216.779V189.503V249.834V252.334H219.279C231.459 252.334 241.333 242.461 241.333 230.281V209.056C241.333 196.877 231.459 187.003 219.279 187.003Z",
    fill: "#8C8C8C",
    stroke: "#6261D6",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.8672,
    y: 152.945,
    width: 183.914,
    height: 129.555,
    rx: 32.5,
    fill: "#8C8C8C",
    stroke: "#6261D6",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4512,
    y: 187.557,
    width: 25.4195,
    height: 43.789,
    rx: 12.7098,
    fill: "#6261D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 154.754,
    y: 187.557,
    width: 25.4195,
    height: 43.789,
    rx: 12.7098,
    fill: "#6261D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.822 141.645C150.24 141.645 166.791 118.835 166.791 90.6976C166.791 62.56 150.24 39.75 129.822 39.75C109.405 39.75 92.8535 62.56 92.8535 90.6976C92.8535 118.835 109.405 141.645 129.822 141.645ZM129.822 131.267C144.481 131.267 156.364 113.103 156.364 90.6973C156.364 68.2914 144.481 50.1279 129.822 50.1279C115.164 50.1279 103.281 68.2914 103.281 90.6973C103.281 113.103 115.164 131.267 129.822 131.267Z",
    fill: "#6261D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404Dark);
export default __webpack_public_path__ + "static/media/error404Dark.c2fe5dd4028725e78e7e55c82de67bef.svg";
export { ForwardRef as ReactComponent };